import { useEffect, useMemo } from 'react';
import { UserAttributeKeys } from '../userAttributes/userAttributesTypes';
import { useUserAttribute } from '../userAttributes/userAttributesQueries';
import { userCompletedContentAfterQuiz } from './recommendationsUtils';
import { useAllProgress } from '../userProgress/userProgressQueries';
import { useRecommendationsState } from './recommendationsStore';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
export const usePrioritizeInterestRecommendations = () => {
  const {
    allProgress: {
      contentProgress
    },
    allProgressLoading: isRequestingProgress
  } = useAllProgress();
  const {
    userAttribute: quizCompletionDate,
    userAttributeLoading,
    userAttributesError
  } = useUserAttribute(UserAttributeKeys.WIZARD_COMPLETION_DATE);
  const prioritizeInterestRecommendations = useMemo(() => {
    if (isRequestingProgress || userAttributeLoading) return undefined;
    return !!quizCompletionDate && !userCompletedContentAfterQuiz(quizCompletionDate, contentProgress);
  }, [contentProgress, isRequestingProgress, quizCompletionDate, userAttributeLoading]);
  const isLoading = prioritizeInterestRecommendations === undefined;
  return {
    prioritizeInterestRecommendations,
    isLoading,
    hasError: userAttributesError
  };
};
export const useSetLastClickedRecommendationItemFromUrl = ({
  id,
  type
}) => {
  const {
    setLastClickedRecommendationItem
  } = useRecommendationsState();
  const [{
    recommendationsCorrelationId,
    recommendationsType
  }, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (recommendationsCorrelationId && recommendationsType === 'ranked' && id && type) {
      setLastClickedRecommendationItem({
        item: {
          id,
          type
        },
        correlationId: recommendationsCorrelationId,
        recommendationEngine: 'ranked'
      });
      setSearchParams({
        recommendationsCorrelationId: undefined,
        recommendationsType: undefined
      });
    }
  }, [recommendationsCorrelationId, recommendationsType, id, type, setLastClickedRecommendationItem, setSearchParams]);
};